import './styles.css';

const gccsPopupEditPayRate = {
  controller: 'PopupEditPayRateController',
  template: require('./template.pug'),
  require: {
    gccsPopupsLayout: '^gccsPopupsLayout'
  },
  bindings: {
    rateChange: '<'
  }
};

angular.module('shared-components.popup.employee').component('gccsPopupEditPayRate', gccsPopupEditPayRate);
